import { render } from "./GlossaryTerm.vue?vue&type=template&id=e4cb76da&scoped=true"
import script from "./GlossaryTerm.vue?vue&type=script&lang=js"
export * from "./GlossaryTerm.vue?vue&type=script&lang=js"

import "./GlossaryTerm.vue?vue&type=style&index=0&id=e4cb76da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4cb76da"]])

export default __exports__